import { ColocaDialog } from "@/shared/components/overlays/ColocaDialog";
import useTranslations from "@/shared/lang/useTranslations";

import type { VerificationPurpose } from "../types/verification-api.types";
import type { VerificationResult } from "../types/verification.types";
import { EmbeddedVerificationFlow } from "./EmbeddedVerificationFlow";

export interface VerificationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  identityId: string;
  purpose: VerificationPurpose;
  onResult?: (result: VerificationResult) => void;
}

/** Marco C — opens the engine for an existing identity inside a `ColocaDialog`. */
export function VerificationDialog({
  open,
  onOpenChange,
  identityId,
  purpose,
  onResult,
}: VerificationDialogProps) {
  const { t } = useTranslations("verification");
  return (
    <ColocaDialog open={open} onOpenChange={onOpenChange} title={t("verify_dialog_title")} size="lg">
      {open ? (
        <EmbeddedVerificationFlow
          identityId={identityId}
          purpose={purpose}
          onResult={onResult}
          onDone={() => onOpenChange(false)}
        />
      ) : null}
    </ColocaDialog>
  );
}
